import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const ClientsSection = () => {
  return (
    <section id="clients" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="section-title">
            Client <span className="gradient-text">Success Stories</span>
          </h2>
          <p className="section-subtitle">
            Discover how Advensify has helped organizations across industries achieve their business goals.
          </p>
        </div>

        {/* Coming Soon Message */}
        <div className="text-center py-12 bg-white rounded-lg shadow-md mb-16">
          <div className="inline-block px-6 py-3 bg-emerald-50 rounded-full">
            <p className="text-emerald-600 font-semibold">Coming Soon: Client Success Stories</p>
          </div>
          <p className="mt-4 text-gray-600">We're currently gathering our success stories to share with you.</p>
        </div>

        {/* Client Logos Section */}
        <div className="bg-white p-8 rounded-xl shadow-md">
          <h3 className="text-center text-xl font-semibold mb-8 font-montserrat">
            Trusted by Industry Leaders
          </h3>
          
          {/* Coming Soon Message for Logos */}
          <div className="text-center py-8">
            <div className="inline-block px-6 py-3 bg-emerald-50 rounded-full">
              <p className="text-emerald-600 font-semibold">Coming Soon: Industry Partners</p>
            </div>
            <p className="mt-4 text-gray-600">We'll be sharing our partnerships with industry leaders soon.</p>
          </div>
          
          {/* <div className="text-center mt-12">
            <Button 
              variant="outline" 
              className="border-emerald-500 text-emerald-600 hover:bg-emerald-50 group"
            >
              Stay Tuned for Updates
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
